import {
  ArrowRight,
  BarChart3,
  Check,
  Eye,
  History,
  Layers3,
  MessageSquareText,
  ShieldCheck,
  Sparkles,
  Star,
  Store,
  Target,
  Users,
  type LucideIcon,
} from "lucide-react";

export type MarketingIconName =
  | "star"
  | "target"
  | "sparkle"
  | "arrow"
  | "layers"
  | "history"
  | "shield"
  | "chart"
  | "message"
  | "users"
  | "store"
  | "eye"
  | "check";

type MarketingIconProps = {
  name: MarketingIconName;
  className?: string | undefined;
};

const ICONS: Record<MarketingIconName, LucideIcon> = {
  star: Star,
  target: Target,
  sparkle: Sparkles,
  arrow: ArrowRight,
  layers: Layers3,
  history: History,
  shield: ShieldCheck,
  chart: BarChart3,
  message: MessageSquareText,
  users: Users,
  store: Store,
  eye: Eye,
  check: Check,
};

export function MarketingIcon({
  name,
  className = "w-5 h-5",
}: MarketingIconProps) {
  const Icon = ICONS[name];

  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      className={className}
      strokeWidth={1.75}
      absoluteStrokeWidth
      data-directional={name === "arrow" ? "true" : undefined}
    />
  );
}

export function marketingIcon(name: MarketingIconName) {
  return <MarketingIcon name={name} />;
}
